document.addEventListener('DOMContentLoaded', function () {
    
    const detailsElements = document.querySelectorAll('details.js-filter');
    
    detailsElements.forEach(detail => {
     
      const summaryLabelElem = detail.querySelector('.facets__summary-label');
      if (summaryLabelElem) {
       
        const labelText = summaryLabelElem.childNodes[0].textContent.trim();
        if (labelText === 'Style') {
          
          detail.style.display = 'none';
        }
      }
    });
});
  